import React from 'react';

import css from './ProfileBar.module.css';
import { AvatarLarge } from '../Avatar/Avatar';
import { H2 } from '../Heading/Heading';
import { FormattedMessage } from 'react-intl';
import NamedLink from '../NamedLink/NamedLink';
import UserNav from '../UserNav/UserNav';
import classNames from 'classnames';

const ProfileBar = props => {
  const {
    user,
    displayName,
    showLinkToProfileSettingsPage,
    actionsContainer = null,
    // currentPage is used to highlight the correct tab in UserNav component,
    // currentPage is required so render UserNav only when currentPage is provided
    currentPage,
    withContainer,
  } = props;

  const rootClassName = classNames(css.root, props.rootClassName, currentPage && css.withNav);
  return (
    <div className={rootClassName}>
      <div className={classNames(css.profileBar, withContainer && css.withContainer)}>
        <AvatarLarge className={css.avatar} user={user} disableProfileLink />
        <H2 as="h1" className={css.heading}>
          {displayName ? (
            <FormattedMessage id="ProfileBar.heading" values={{ name: displayName }} />
          ) : null}
        </H2>
        {showLinkToProfileSettingsPage ? (
          <>
            <NamedLink className={css.editLinkMobile} name="ProfileSettingsPage">
              <FormattedMessage id="ProfileBar.editProfileLinkMobile" />
            </NamedLink>
            <NamedLink className={css.editLinkDesktop} name="ProfileSettingsPage">
              <FormattedMessage id="ProfileBar.editProfileLinkDesktop" />
            </NamedLink>
          </>
        ) : null}
        {actionsContainer}
      </div>
      {currentPage && <UserNav className={css.nav} currentPage={currentPage} />}
    </div>
  );
};

export default ProfileBar;
